import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useNavigate, useParams } from '@tanstack/react-router';
import { toast } from 'sonner';

const useManageHostInfo = () => {
  const navigate = useNavigate();
  const params = useParams({ from: '/(app)/store-information/premium-stores/host-management/$clubid/$manage-host' });
  const { mutateAsync } = useMutation('manageHostInfo', {
    onSuccess: async (data) => {
      toast.success(data.message);
      void navigate({
        to: '/store-information/premium-stores/host-management/$clubid',
        params: {
          clubid: params['clubid'],
        },
      });
      await revalidate(['hostDetail', 'clubHosts', 'clubBasicInfo', 'all', 'editorRecommendedStores']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync };
};

export default useManageHostInfo;
